const config: siteConfig = {
  //  REACT_APP_API_URL: "http://localhost/sds_efl_background/api",
 REACT_APP_API_URL: "https://efl.tthefl.com/api",
// REACT_APP_API_URL: "http://192.168.1.35/softdigisolutions/sds_efl_backend/api/",
  ENCRYPTION_KEY: "your-secret-key",
  DIGI_SERVER_URL:"http://localhost:3000/"
};

export default config;
